@if (loading && entries.length == 0) {
  <div>
    Loading devices ...
  </div>
}

@if (!loading && entries.length == 0) {
  <div>
    No devices found
  </div>
}

@if (entries.length > 0) {
  <div>
      <uv-table #dt class="device-table" testID="1" [columns]="cols" [value]="entries" dataKey="dataKey"
                [resizableColumns]="true" [(first)]="first" [contextMenu]="cm" [(contextMenuSelection)]="cmSelectedDevice"
                [scrollable]="true" scrollHeight="calc(100vh - 300px)"
                [customSort]="true" (sortFunction)="doCustomSort($event)"
                selectionMode="single" [(selection)]="selectedEntry"
                (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
                (onFilter)="onFilter($event)" [virtualScroll]="true" [virtualScrollItemSize]="VirtualScrollItemSize">
          <ng-template pTemplate="caption">
              <div>
                  <button type="button" pButton icon="fa fa-search" iconPos="left" label="Find IP"
                          [disabled]="!selectedEntry && !ipFilterValue" (click)="findIpMac(AddressType.Ip)"></button>
                  <button type="button" pButton icon="fa fa-search" iconPos="left" label="Find MAC"
                          [disabled]="!selectedEntry && !macFilterValue" (click)="findIpMac(AddressType.Mac)"></button>
                  <button type="button" pButton icon="fa fa-file-o" iconPos="left" label="Export"
                          (click)="dt.exportCSV()"></button>
              </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
              <tr>
                  @for (col of columns; track col) {
                  <th uvResizableColumn [uvSortableColumn]="col.field">
                      {{col.header}}
                      <uv-sortIcon [field]="col.field"></uv-sortIcon>
                  </th>
                  }
              </tr>
              <tr class="uv-table-filter">
                  @for (col of columns; track col) {
                  <th>
                      <input pInputText type="text" style="width: 100%;"
                             (input)="dt.filter($event.target.value, col.field, col.filterMatchMode); clearSelection();">
                  </th>
                  }
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [style]="TableRowStyle" [uvSelectableRow]="rowData" [uvContextMenuRow]="rowData">
                  @for (col of columns; track col) {
                  <td>
                      <span class="uv-table-value">{{rowData[col.field]}}</span>
                  </td>
                  }
              </tr>
          </ng-template>
      </uv-table>
    </div>
  }

  <p-contextMenu #cm [model]="cmItems" appendTo="body" [baseZIndex]="4000"></p-contextMenu>

  <device-details #devicedetails [selectedDevice]="selectedDevice"></device-details>

  <ip-mac-finder-result-dialog [(visible)]="ipMacFinderResultDialogVisible" [sightings]="ipMacSightings"></ip-mac-finder-result-dialog>


  @if (UseOffCanvas) {
    <uvx-offcanvas #detailsOffCanvas [title]="selectedDevice?.displayName + ' Details'">
      <ng-template>
        <info-sets #infosets [selectedDevice]="selectedDevice"></info-sets>
      </ng-template>
    </uvx-offcanvas>
  }

  <!-- <tablevirtualscrolldemo></tablevirtualscrolldemo> -->
